// extracted by mini-css-extract-plugin
export default {"featureOverridesTable":"dc11f46f01e2","mobileOverrideList":"b7b5eb59b313","actionsColumnHeader":"c739a2e4a9d5","noWrapCell":"cacfdb097550"};